import { HeroKeyFields } from '@symplbe/sympl-components';
import { WithPlaceholder } from 'types/careers-page/section';

import { getSectionHeaderDefaultConfig } from '../shared/defaultConfig';

export const defaultHeroSettings: HeroKeyFields & WithPlaceholder = {
  ...getSectionHeaderDefaultConfig(),
  images: [],
};
